module.exports = __webpack_public_path__ + "img/face-hand-yawn.915518d6.svg";